import { fg } from '@atlaskit/platform-feature-flags';
import { useRovoContext } from '../rovo-context/rovo-context';
import { useUserContext } from '../user-context';
export var useShowAtlassianHomeSearchLink = function useShowAtlassianHomeSearchLink(primaryProduct) {
  var _useRovoContext = useRovoContext(),
    isRovoEnabled = _useRovoContext.isRovoEnabled;
  var _useUserContext = useUserContext(),
    orgId = _useUserContext.orgId;
  return !!(isRovoEnabled && orgId && primaryProduct === 'jira' && fg('jira_rovo_in_quick_search'));
};